import groq from 'groq'
import { imageAsset } from '../../imageAsset'

export const solution = groq`
 _type,
  topNote,
  title,
  backgroundImageDesktop {...${imageAsset()}},
  backgroundImageMobile {...${imageAsset()}},
  description,
`
